"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAcceptPunchCorrection = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const taaConfigs_1 = require("../../contexts/taaConfigs");
function useAcceptPunchCorrection({ employeeId, onSuccessCallback, usageLocation }) {
    const { clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const { isLoading: loading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.submitData)(currentStage));
    const [data, setData] = (0, react_1.useState)('');
    const [retryParams, setRetryParams] = (0, react_1.useState)();
    const acceptPunchCorrection = (correctionId) => {
        setRetryParams(undefined);
        setData('');
        mutate({
            path: (0, paths_1.ACCEPT_PUNCH_CORRECTION_API)(employeeId || '', correctionId),
            method: 'PATCH',
            metaData: {
                apiName: 'acceptPunchCorrection',
                clientName
            },
            usageLocation
        }, {
            onSuccess: () => {
                if (onSuccessCallback) {
                    onSuccessCallback();
                }
                setData(correctionId);
            },
            onError: () => {
                setRetryParams({ correctionId });
            }
        });
    };
    const retry = () => {
        if (!retryParams || loading)
            return;
        const { correctionId } = retryParams;
        acceptPunchCorrection(correctionId);
    };
    return {
        acceptPunchCorrectionState: {
            data,
            loading,
            error: retryParams ? error : undefined,
            retry
        },
        acceptPunchCorrection
    };
}
exports.useAcceptPunchCorrection = useAcceptPunchCorrection;
